module.exports = __webpack_public_path__ + "res/img_reward_m.5991cc139ae96206d70f19926eb8a416.png";